'use client'
import React, {ReactNode, useContext} from 'react'
import {usePathname} from "next/navigation";

import useWindowDimensions from "@/libs/contentful/helper/useWindowDimension";
import clsx from "clsx";
import {MobileNavContext} from "@/components/Layout/Header/Navigation/MainNavProvider";
import Link from "next/link";

interface Props {
    className?: string
    slug: string
    type?: string
    children: ReactNode
    ariaLabel?: string
}

const NavLink = ({className, slug, type, children, ariaLabel}:Props) => {
    const { toggleMobileNav } = useContext(MobileNavContext);
    const { width } = useWindowDimensions();
    const mobileMegaMenuToggle = (e:any) => {
        e.currentTarget.blur()
        if (width !== undefined && width < 834 && e.target.nextElementSibling) {
            e.preventDefault()
        }
    }

    const handleLinkClick = (e:any) => {
        e.currentTarget.blur();
        toggleMobileNav ? toggleMobileNav(false) : null
    }

    const urlPattern = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    return (
        <Link
            className={clsx(className)}
            href={slug}
            target={urlPattern.test(slug) ? '_blank' : '_self'}
            aria-label={ariaLabel}
            aria-current={slug + '/' === usePathname() ? "page" : undefined}
            tabIndex={type === 'pageLink' && width !== undefined && width < 834 ? -1 : undefined}
            onClick={type === 'pageLink' ? mobileMegaMenuToggle : handleLinkClick}
        >
            {children}
        </Link>
    )
}

export default NavLink
